import React from 'react';

export const BuildingLogo = ({ width = '18', height = '18', fill = 'var(--icon-color-base)' }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_1263_3890)">
        <path
          d="M5.875 15.5V11.4375C5.875 10.92 6.295 10.5 6.8125 10.5H8.6875C9.205 10.5 9.625 10.92 9.625 11.4375V15.5M9.625 15.5H13.375V0.954165M9.625 15.5H15.875V6.95835M13.375 0.954165L14.625 0.5M13.375 0.954165L4.625 4.13666M15.875 6.95835L13.375 6.125M15.875 6.95835L17.125 7.375M4.625 4.13666V0.5H2.125V15.5M4.625 4.13666L0.875 5.5M0.875 15.5H2.125M2.125 15.5H17.125"
          stroke={fill}
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1263_3890">
          <rect width="18" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
